<form-layout
    [overrideTitle]="'contact-data.antragstellerTitle' | translate" 
    [showSave]="canSave"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">

    <applicant-form [form]="contactDataProcessStepForm"></applicant-form>
</form-layout>
